var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAUiArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 9,
    viewBox: "0 0 128 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.354 4.85355C127.549 4.65829 127.549 4.34171 127.354 4.14645L124.172 0.964466C123.976 0.769204 123.66 0.769204 123.464 0.964466C123.269 1.15973 123.269 1.47631 123.464 1.67157L126.293 4.5L123.464 7.32843C123.269 7.52369 123.269 7.84027 123.464 8.03553C123.66 8.2308 123.976 8.2308 124.172 8.03553L127.354 4.85355ZM0 5H127V4H0V5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAUiArrow2);
export default __webpack_public_path__ + "static/media/aUI_Arrow_2.4ffaaea94894f76eb396eb11dae38370.svg";
export { ForwardRef as ReactComponent };